import { fetchWithAuth } from '../utils/apiUtils';

export default class JobsService {
  private static jobsPath = 'job/jobs';

  public static async searchJobs() {
    return await fetchWithAuth(`${this.jobsPath}/search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },  
      body: JSON.stringify({
      }),
    });
  }
  public static async getJobById(jobId: string){
    return await fetchWithAuth(`${this.jobsPath}/${jobId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  public static async getPendingJobs(){
    return await fetchWithAuth(`${this.jobsPath}/search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        status: 'PENDING_MANAGER_APPROVAL'
      }),
    });
  }

  public static async acceptJob(jobId: string){
    return await fetchWithAuth(`${this.jobsPath}/${jobId}/accept`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  public static async rejectJob(jobId: string){
    return await fetchWithAuth(`${this.jobsPath}/${jobId}/reject`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  public static async getLatestJob(){
    return await fetchWithAuth(`${this.jobsPath}/latest`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      cache: 'no-store'
    });
  }
}